/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "Too many requests just now. Please try again in a moment." |
*
* @param {Canvas_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_rate_limited = /** @type {((inputs?: Canvas_Rate_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Rate_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gerade zu viele Anfragen. Bitte in einem Moment erneut versuchen.")
	return /** @type {LocalizedString} */ ("Too many requests just now. Please try again in a moment.")
});